export const formatSalt = (num?: number) => (num !== undefined ? num.toFixed(2) : '-.--')
